import React, { useEffect, useState } from 'react';
import './ChartCustomSocioeconomicalsComponent.css';
import { useSelector } from 'react-redux';
import Axios from 'axios';
import { Radio, RadioGroup } from '@hastom/react-radio-group';
import ChartBarVerticalComponent from '../ChartBarVerticalComponent/ChartBarVerticalComponent';
import ChartBarHorizontalComponent from '../ChartBarHorizontalComponent/ChartBarHorizontalComponent';
import chartProccessSocio from '../../../helpers/charts/chartProccessSocio';
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import encodeCache from '../../../helpers/cache/encode';
import userAuth from '../../../helpers/auth/userAuth';

const config = { method: 'get', url: '', headers: { Authorization: '' } };
const cors = process.env.REACT_APP_CORS;
const back_end_stats = process.env.REACT_APP_BACK_END_STATS;

const ChartCustomSocioeconomicalsComponent = (props) => {
  const { name } = props.data;
  const { id } = props.data;
  const analisis = useSelector((store) => store.analizer.id);
  const auth = userAuth();

  const [chart, setChart] = useState([]);
  const [size, setSize] = useState('md');
  const [type, setType] = useState('horizontal');
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState(false);
  const [print, setPrint] = useState(true);

  const load = async () => {
    setLoading(true);
    let xd;
    switch (id) {
      case 'geotarget':
        xd = 'geo-target';
        break;
      default:
        xd = id;
    }
    config.url = `${cors}${back_end_stats}/wise-stats/${xd}/${analisis}`;
    config.headers.Authorization = `Bearer ${auth.access_token}`;
    const res = await (await Axios(config)).data;
    const result = chartProccessSocio(res, props.data.data);
    const exporter = {
      id: `chart-0-custom-socioeconomicals-${id}`, size, data: result, color: '#2B364A', print, name,
    };
    encodeCache(`chart-0-custom-socioeconomicals-${id}`, exporter);
    setChart(result);
    setLoading(false);
  };

  useEffect(() => {
    if (!analisis) return;
    load();
  }, [analisis]);

  const changeSize = (e) => {
    setSize(e);
    const exporter = {
      id: `chart-0-custom-socioeconomicals-${id}`, size: e, data: chart, color: '#2B364A', print, name,
    };
    encodeCache(`chart-0-custom-socioeconomicals-${id}`, exporter);
  };

  const changeType = (e) => setType(e);

  const changePrint = (e) => {
    setPrint(e);
    const exporter = {
      id: `chart-0-custom-socioeconomicals-${id}`, size, data: chart, color: '#2B364A', print: e, name,
    };
    encodeCache(`chart-0-custom-socioeconomicals-${id}`, exporter);
  };

  return chart.length > 0 ? (
    <section id="chart-custom-socioeconomicals" className={`chart-custom-socioeconomicals-size-${size}`}>
      <LoadingComponent data={loading} />
      <div className="actions">
        <div className="size">
          <RadioGroup selectedValue={size} onChange={changeSize}>
            <label>
              <Radio value="lg" />
              <i className={size === 'lg' ? 'ion-arrow-expand active' : 'ion-arrow-expand'} />
            </label>
            <label>
              <Radio value="md" />
              <i className={size === 'md' ? 'ion-arrow-shrink active' : 'ion-arrow-shrink'} />
            </label>
          </RadioGroup>
        </div>
        <div className="print">
          <RadioGroup selectedValue={print} onChange={changePrint}>
            <label>
              <Radio value={!print} />
              <i className={print === true ? 'ion-android-print active' : 'ion-android-print'} />
            </label>
          </RadioGroup>
        </div>
        <div className="type">
          <RadioGroup selectedValue={type} onChange={changeType}>
            <label>
              <Radio value="horizontal" />
              <i className={type === 'horizontal' ? 'ion-stats-bars active' : 'ion-stats-bars'} />
            </label>
            <label>
              <Radio value="vertical" />
              <div className="rotate-icon">
                <i className={type === 'vertical' ? 'ion-stats-bars active' : 'ion-stats-bars'} />
              </div>
            </label>
            <a onClick={() => setInfo(!info)} className={info ? 'view-info active' : 'view-info'}>
              <i className="ion-information-circled" />
            </a>
          </RadioGroup>
        </div>
      </div>
      <div id={`chart-0-custom-socioeconomicals-${id}`}>
        <h3>{name}</h3>
        {
                    type === 'vertical' && (<ChartBarVerticalComponent data={chart} info={info} />)
                }
        {
                    type === 'horizontal' && (<ChartBarHorizontalComponent data={chart} info={info} />)
                }
      </div>
    </section>
  ) : null;
};

export default ChartCustomSocioeconomicalsComponent;
